import memoize from 'transmute/memoize';
import { buildRecipientLocator } from './buildRecipientLocator';
export const findLegacyRecipient = memoize((recipientId, recipientType, recipients) => {
  if (!recipientType) {
    return null;
  }
  return recipients.get(buildRecipientLocator(recipientType, recipientId));
});